// PlatformNav — the sysadmin platform-context tabs in the top bar (Projects /
// Users), the platform-zone parallel to the project domains (PrimaryNav).
//
// Renders the PLATFORM_NAV slice of the nav registry. The platform context is
// sysadmin-only (ADR-018 trust zone), so visibility is gated purely on
// is_sysadmin — no per-item permission key. Text-only like PrimaryNav; only two
// tabs today, so no overflow handling. Mounted by the Navbar only in platform
// context; the same tabs appear in the mobile hamburger.

import { useTranslation } from 'react-i18next';
import { NavLink } from '../ui/NavLink.js';
import { useMe } from '../../hooks/useMe.js';
import { PLATFORM_NAV, platformNavPath } from '../../config/nav.js';

export function PlatformNav() {
  const { t } = useTranslation('nav');
  const { data: me } = useMe();
  if (!me?.user.is_sysadmin) return null;

  return (
    <nav
      aria-label={t('landmarks.platform')}
      className="hidden md:flex flex-1 min-w-0 items-stretch h-14 gap-1 ms-2"
    >
      {PLATFORM_NAV.map((item) => (
        <NavLink key={item.id} to={platformNavPath(item.route)} variant="topbar">
          <span className="whitespace-nowrap">{t(item.labelKey)}</span>
        </NavLink>
      ))}
    </nav>
  );
}
